import React from 'react';
import BaseScadaNode from './BaseScadaNode';

export default function TextLabelNode(props) {
    const { data } = props;
    const config = data?.config || {};
    return (
        <BaseScadaNode {...props}>
            <div style={{
                width: '100%',
                height: '100%',
                display: 'flex',
                alignItems: config.align_v || 'center',
                justifyContent: config.align_h || 'center',
                fontSize: config.font_size || 14,
                fontWeight: config.bold ? 'bold' : 'normal',
                color: config.color || '#F1F5F9',
                padding: 4,
                textAlign: 'center',
                wordBreak: 'break-word',
                userSelect: 'none',
            }}>
                {data?.label || 'Text'}
            </div>
        </BaseScadaNode>
    );
}
